import {CustomerService} from "../resource";

const CustomerModule = {
    namespaced: true,
    state: {
		datas: [],
	},
    mutations: {
		SET_DATA(state, data) {
			state.datas = data;
		}
	},
    actions: {
		async listData({ commit, state }, data) {
			try
			{
				const response = await CustomerService.CustomerList(data);
				commit("SET_DATA", response.data.Data);
			}
			catch (error)
			{
				console.log(error)
				commit("SET_DATA", []);
			}
		},

		searchData({ commit, state }, data) {
			return CustomerService.CustomerList(data);
		},

		createData({ commit, state }, data) {
			return CustomerService.CustomerCreate(data);
		},

		updateData({ commit, state }, data) {
			return CustomerService.CustomerUpdate(data.id,data.payload);
		},

		deleteData({ commit, state }, data) {
			return CustomerService.CustomerDelete(data);
		},

		updateCustomerStatus({ commit, state }, data) {
			return CustomerService.CustomerUpdateStatus(data);
		},
	},
	getters: {
		getData(state) {
			return state.datas;
		}
	}

};

export default CustomerModule;
